import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetPriceChangeItems($input: GetPriceChangeItemsInput!) {
    priceChange {
      getPriceChangeItems(input: $input) {
        ... on GetPriceChangeItemsSuccess {
          priceChangeItems {
            id
            incoterms
            incotermsLocationId
            incotermsLocation {
              ...LocationBaseFields
            }
            lastLaidDownCost
            acceptedCost
            product {
              productId
              vendorDescription
              externalSystemId
              computedProductStatus
              packageUsWeightUom
              company {
                name
              }
              locationsAssociations {
                locationAssociationId
                shipping {
                  ...LocationBaseFields
                }
              }
            }
            shipFromWarehouseArea {
              warehouseAreaId
              locationId
              location {
                name
                city
                regionIsoCode
              }
            }
            items {
              id
              priceChangeItemId
              customerId
              customer {
                name
              }
              shipToLocationId
              freightTerms
              last12MonthsQty
              effectiveDate
              expirationDate
              billBack
              previousBillBack
              tiers {
                id
                qty
                uom
                price
                profit
                margin
                surcharge1Price
                surcharge1Description
                surcharge2Price
                surcharge2Description
                surcharge3Price
                surcharge3Description
              }
            }
          }
          pageInfo {
            total
            limit
            offset
          }
        }
        ... on GetPriceChangeItemsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetPriceChangeFilterOptions($input: GetPriceChangeFilterOptionsInput!) {
    priceChange {
      getPriceChangeFilterOptions(input: $input) {
        ... on GetPriceChangeFilterOptionsSuccess {
          filterOptions {
            suppliers {
              ...PriceChangeFilterOptionBaseFields
            }
            customers {
              ...PriceChangeFilterOptionBaseFields
            }
            productCategories {
              ...PriceChangeFilterOptionBaseFields
            }
            productClasses {
              ...PriceChangeFilterOptionBaseFields
            }
            products {
              ...PriceChangeFilterOptionBaseFields
            }
            shipFromWarehouseAreas {
              ...PriceChangeFilterOptionBaseFields
            }
            shipToLocations {
              ...PriceChangeFilterOptionBaseFields
            }
          }
        }
        ... on GetPriceChangeFilterOptionsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
